import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import SearchBar from "@/components/feature/SearchBar";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "综艺", to: "/category/variety" },
  { label: "演员资料", to: "/category/actor" },
  { label: "关于我们", to: "/about" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.search]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isActive = (to: string) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  return (
    <header
      className={`sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b transition-colors ${
        scrolled ? "border-background-200" : "border-transparent"
      }`}
    >
      <div className="max-w-content mx-auto px-4 md:px-6 h-16 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-film-line text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading font-black text-xl text-foreground-950 tracking-wide">
              葵司
            </span>
            <span className="text-[11px] text-foreground-500 tracking-widest">
              影视资讯 · 演员资料
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`px-3 h-9 flex items-center rounded-md text-sm whitespace-nowrap transition-colors ${
                isActive(item.to)
                  ? "text-accent-600 font-medium"
                  : "text-foreground-700 hover:text-accent-600"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:block w-72 shrink-0">
          <SearchBar size="sm" />
        </div>

        <button
          type="button"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          onClick={() => setOpen((v) => !v)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50">
          <div className="px-4 py-4">
            <SearchBar />
            <nav className="mt-4 flex flex-col">
              {navItems.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`px-2 h-11 flex items-center rounded-md text-base whitespace-nowrap transition-colors ${
                    isActive(item.to)
                      ? "text-accent-600 font-medium"
                      : "text-foreground-700"
                  }`}
                >
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}